export default __webpack_public_path__ + "static/media/paypal.4680a15c.svg";